
document.addEventListener("DOMContentLoaded", function() {
    let scrollBtn = document.getElementById("scrollToTop");

    window.onscroll = function() {
        if (document.body.scrollTop > 300 || document.documentElement.scrollTop > 300) {
            scrollBtn.style.display = "block";
        } else {
            scrollBtn.style.display = "none";
        }
    };

    scrollBtn.onclick = function() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
});

// input name,phone no lenth field validation 
document.addEventListener("DOMContentLoaded", function () {
    const nameInput = document.getElementById("ContactForm-name");
    const phoneInput = document.getElementById("ContactForm-phone");
    const submitButton = document.querySelector(".contact__button button");

    function validateName() {
        const nameValue = nameInput.value.trim();
        const isValid = /^[A-Za-z\s]+$/.test(nameValue);

        if (isValid) {
            showError(nameInput, "", true);
        } else {
            showError(nameInput, "Only letters are allowed!");
        }
        validateForm();
    }

    function validatePhone() {
        let phoneValue = phoneInput.value.replace(/\D/g, ""); // Remove non-numeric characters
        phoneInput.value = phoneValue; // Ensure only numbers remain

        if (phoneValue.length === 10) {
            showError(phoneInput, "", true);
        } else {
            showError(phoneInput, "Enter a valid 10-digit phone number!");
        }
        validateForm();
    }

    function validateForm() {
        if (nameInput.value.match(/^[A-Za-z\s]+$/) && phoneInput.value.length === 10) {
            submitButton.disabled = false;
            submitButton.style.opacity = "1";
        } else {
            submitButton.disabled = true;
            submitButton.style.opacity = "0.5";
        }
    }

    function showError(input, message, clear = false) {
        let parentDiv = input.closest("div"); // Get closest parent div
        let errorDiv = parentDiv.querySelector(".error-message");

        if (clear) {
            if (errorDiv) {
                errorDiv.remove();
            }
            return;
        }

        if (!errorDiv) {
            errorDiv = document.createElement("div");
            errorDiv.className = "error-message";
            parentDiv.appendChild(errorDiv);
        }

        errorDiv.textContent = message;
        errorDiv.style.color = "red";
        errorDiv.style.margin = "54px 18px";
        errorDiv.style.fontSize = "14px";
        errorDiv.style.position = "absolute"; // Ensure it stays below
        errorDiv.style.display = "block"; // Force new line
        errorDiv.style.width = "100%"; // Full width to prevent side display
    }

    // Event Listeners
    nameInput.addEventListener("input", validateName);
    phoneInput.addEventListener("input", validatePhone);

    validateForm(); // Initial check
});
